import React from 'react';
import { PropTypes as T } from 'prop-types';

export default function FormRow({ children, className, ...props }) {
  return (
    <div className={['form-row', className].filter(c => c).join(' ')} {...props}>
      { children }
    </div>
  );
}

FormRow.propTypes = {
  className: T.string,
  children: T.oneOfType([
    T.arrayOf(T.node),
    T.node,
  ]),
};

FormRow.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./app/components/bootstrap/form_row/index.jsx